export default __webpack_public_path__ + "static/media/tesla-reactjs.9c033aa1.JPG";